import { ReactComponent as ErrorIconSvg } from "@icons/Error_Icon.svg";
import { ReactComponent as InfoIconSvg } from "@icons/Info_Icon.svg";
import { ReactComponent as SuccessIconSvg } from "@icons/Success_Icon.svg";
import Button, { ButtonProps } from "shared/UI/Buttons/Button";

export interface StatusPageProps {
  status: "info" | "error" | "success";
  title: string;
  body: JSX.Element | string;
  cta: ButtonProps;
}

export const StatusPage = (props: StatusPageProps) => {
  const { status, title, body, cta } = props;

  let Icon;
  switch (status) {
    case "error":
      Icon = ErrorIconSvg;
      break;
    case "success":
      Icon = SuccessIconSvg;
      break;
    case "info":
    default:
      Icon = InfoIconSvg;
  }
  return (
    <div data-testid={`${status}-status-screen`} className="flex items-center justify-center h-screen px-6 sm:px-[5rem]">
      <div className="space-y-4 text-center md:w-96">
        <div className="flex justify-center w-full item-center">
          <Icon width={50} height={50} />
        </div>
        <div>
          <h2 className="text-center">{title}</h2>
          {typeof body === "string" ? (
            <p className="w-full text-center" dangerouslySetInnerHTML={{ __html: body }}></p>
          ) : (
            <p className="w-full text-center">{body}</p>
          )}
        </div>
        <div className="space-y-4 pt-4">
          <Button data-testid={cta.id} {...cta} />
        </div>
      </div>
    </div>
  );
};
